import { useCallback, useEffect, useState } from 'react';

const POLL_MS = 30000;

/** A count for a header badge. Polls every 30 s while the tab is
 *  visible, and refreshes on focus and whenever one of `events` fires
 *  on window. `fetchCount` and `events` must be stable (module-level). */
export default function usePolledCount(fetchCount, events) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (document.visibilityState === 'hidden') return;
    try {
      setCount(Number(await fetchCount()) || 0);
    } catch {
      // Badge is best-effort; keep the last value.
    }
  }, [fetchCount]);

  useEffect(() => {
    void refresh();
    const timer = setInterval(() => { void refresh(); }, POLL_MS);
    const onSignal = () => { void refresh(); };
    const names = ['focus', ...events];
    names.forEach((name) => window.addEventListener(name, onSignal));
    return () => {
      clearInterval(timer);
      names.forEach((name) => window.removeEventListener(name, onSignal));
    };
  }, [refresh, events]);

  return count;
}
